import { render, staticRenderFns } from "./generator.polygon.thumbnail.object.preview.vue?vue&type=template&id=7ac2fb80&"
import script from "./generator.polygon.thumbnail.object.preview.vue?vue&type=script&lang=ts&"
export * from "./generator.polygon.thumbnail.object.preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports